module.exports = __webpack_public_path__ + "img/englishTeacher-lg.866a8ba7.png";